<template>
  <div class="row" v-if="kiosk">
    <div class="col-md-6 offset-md-3">
      <!-- Error Alert -->
      <danger-alert :errors="errors"></danger-alert>

      <form v-on:submit.prevent="editKiosk" class="col-md-12">
        <div class="form-group">
          <label for="org-name">Kiosk Name</label>
          <input
            type="text"
            class="form-control"
            v-model="kiosk.name"
            placeholder="name"
            id="org-name"
            name="org-name"
          />
        </div>

        <div class="form-group">
          <label for="height">Height</label>
          <input
            type="text"
            class="form-control"
            v-model="kiosk.properties.height"
            placeholder="name"
            id="height"
            name="height"
          />
        </div>

        <div class="form-group">
          <label for="width">Width</label>
          <input
            type="text"
            class="form-control"
            v-model="kiosk.properties.width"
            placeholder="name"
            id="width"
            name="width"
          />
        </div>

<!--        <div class="form-group">-->
<!--          <label for="kiosk_mode">Kiosk Mode</label>-->
<!--          <input-->
<!--            type="checkbox"-->
<!--            class="form-control"-->
<!--            id="kiosk_mode"-->
<!--            v-model="kiosk.properties.kiosk_mode"-->
<!--            :true-value="true"-->
<!--            :false-value="false"-->
<!--            :checked="kiosk.properties.kiosk_mode"-->
<!--          />-->
<!--        </div>-->

        <div class="form-group">
          <label for="debug_mode">Debug Mode</label>
          <input
            type="checkbox"
            class="form-control"
            id="debug_mode"
            v-model="kiosk.properties.debug_mode"
            :true-value="true"
            :false-value="false"
            :checked="kiosk.properties.debug_mode"
          />
        </div>

        <div class="form-group">
          <!-- Plain mode -->
          <b-form-file v-model="kiosk.icon" class="mt-3" accept="image/jpeg, image/png" plain></b-form-file>
          <div class="mt-3">Selected file: {{ kiosk.icon ? kiosk.icon.name : '' }}</div>
        </div>

        <tags-input element-id="tags"
                    v-model="kiosk.tags"
                    :typeahead="true"></tags-input>

        <br/>

        <div class="form-group">
          <router-link :to="{ name: 'KioskShow', params: { id: kiosk.id } }" tag="a" role="button" class="btn btn-light mr-1">Back</router-link>
          <input type="submit" class="btn btn-primary" value="Submit" />
        </div>
      </form>
    </div>
  </div>
  <loading-overlay v-else></loading-overlay>
</template>

<script>

import { KioskService } from '@/common/services/kiosk.service';
import DangerAlert from '@/common/components/danger-alert.vue';
import LoadingOverlay from '@/common/components/loading-overlay.vue';
import { useKiosksStore } from '@/stores/KiosksStore';
import PermissionsService from '@/common/services/user_permissions.service';

export default {
  name: 'KioskEdit',
  components: {
    DangerAlert,
    LoadingOverlay,
  },
  setup() {
    const kiosksStore = useKiosksStore();

    return {
      kiosksStore,
    };
  },
  data() {
    return {
      kiosk: null,
      errors: [],
      tag: '',
    };
  },
  created() {
    if (!PermissionsService.isAdmin()) {
      this.$router.push({ name: 'KioskShow', params: { id: this.$route.params.id } });
    }
    this.getKiosk(this.$route.params.id);
    this.kiosksStore.$subscribe(() => {
      this.getKiosk(this.$route.params.id);
    });
  },
  methods: {
    getKiosk(id) {
      const kiosk = this.kiosksStore.getKioskById(parseInt(id));
      if (kiosk) {
        this.kiosk = kiosk;
      }
    },
    editKiosk() {
      const payload = { name: this.kiosk.name, properties: this.kiosk.properties, tags: this.kiosk.tags };
      KioskService.update(this.$route.params.id, payload)
        .then((response) => {
          if (this.kiosk.icon) {
            const formData = new FormData();
            formData.set('kiosk[icon]', this.kiosk.icon);
            return KioskService.multipartEdit(response.data.id, formData);
          }
          return response;
        })
        .then((response) => {
          this.$router.push({ name: 'KioskShow', params: { id: this.kiosk.id } });
          this.$notify({
            title: 'Edited Kiosk',
            text: `Successfully edited ${response.data.name}!`,
            type: 'success',
            width: 350,
          });
        })
        .catch((err) => {
          this.errors = err.response.data.error;
          this.$notify({
            title: 'Could not submit form!',
            text: this.errors.join(' '),
            type: 'error',
            width: 350,
          });
        });
    },
  },
};
</script>

<style lang="scss">
  @import "./../../styles/components/vue-tagsinput";
</style>
